import { render, staticRenderFns } from "./AgencyList.vue?vue&type=template&id=05927608&scoped=true&"
import script from "./AgencyList.vue?vue&type=script&lang=js&"
export * from "./AgencyList.vue?vue&type=script&lang=js&"
import style0 from "./AgencyList.vue?vue&type=style&index=0&id=05927608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05927608",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VPagination,VRow})
